// extracted by mini-css-extract-plugin
export default {"footer-section":"Footer_footer-section__A3fJA","footer":"Footer_footer__2Asaa","footer-links":"Footer_footer-links__Fgn9W"};